export const state = () => ({
  item: { ...defaultItem }
});

export const mutations = {
  reset (state, item) {
    state.item = { ...defaultItem, ...(item || {}) };
  },
  set (state, item) {
    state.item = { ...state.item, ...(item || {}) };
  }
};

export const getters = {
  get (state) {
    return state.item;
  }
};

const defaultItem = { insured_value: 0, item_type: '', name: '' };
